exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".promo[data-v-e7c108d2]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-e7c108d2&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/YourAllegroComparison/details.vue
// module id = 939
// module chunks = 2